import { useTitle } from 'contexts/TitleProvider';
import { useUser } from 'contexts/UserProvider';
import { useEffect, useMemo } from 'react';
import FilterTeamRevenue from './FilterTeamRevenue';

const TeamRevenuePage = () => {
  const { user } = useUser();
  const { setTitle, setBreadcrumb } = useTitle();

  const defaultFilter = useMemo(() => {
    const userAny = user as any;

    if (user?.plantCode === '5000') return {};

    if (user?.isSale) {
      const teamSale = userAny?.teamSales?.[0];

      return {
        plantId: userAny?.plantCode,
        teamSalesId: teamSale?.id || 'SALE_ID',
        teamSalesSubId: teamSale?.subId || 'SALE_SUB_ID',
        teamSalesName: teamSale?.name,
      };
    }

    return {
      plantId: userAny?.plantCode,
    };
  }, [user]);

  useEffect(() => {
    setTitle('Doanh thu đội');
    setBreadcrumb([{ title: 'Báo cáo' }, { title: 'Doanh thu đội' }]);
  }, [setBreadcrumb, setTitle]);

  return (
    <>
      <FilterTeamRevenue defaultFilter={defaultFilter} />

      {/* <TableTeamRevenue
      defaultFilter={defaultFilter}
      loading={getAllExpensesLoading}
      ref={tableRef}
      data={data}
      refetch={refetch}
      /> */}
    </>
  );
};

export default TeamRevenuePage;
